import { Float, Int } from '@adornis/baseql/baseqlTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

//TODO: handle unified interface for all DBs (like Apollo) later
@Entity()
export class EigenLeadProviderDoc extends MongoEntity {
  static override _class = 'EigenLeadProviderDoc';

  @Field(type => String) provider!: string;
  @Field(type => String) providerLeadId?: string;
  @Field(type => String) providerCompanyId?: string;
  @Field(type => String) lastSeenAt!: string;
  @Field(type => String) lastEnrichedAt?: string;
  @Field(type => Float) confidence?: number;
  @Field(type => String) raw?: string;
}

@Entity()
export class EigenLead extends MongoEntity {
  static override _class = 'EigenLead';
  static override _collectionName = 'eigen_leads';

  @Field(type => String) canonicalKey!: string;
  @Field(type => String) primaryEmail?: string;
  @Field(type => String) emailHash?: string;
  @Field(type => String) linkedinUrl?: string;
  @Field(type => String) linkedinSlug?: string;
  @Field(type => String) fullName?: string;
  @Field(type => String) firstName?: string;
  @Field(type => String) lastName?: string;

  @Field(type => [String]) emails?: string[];
  @Field(type => [String]) phones?: string[];
  @Field(type => String) primaryPhone?: string;

  @Field(type => String) jobTitle?: string;
  @Field(type => String) department?: string;
  @Field(type => String) seniority?: string;
  @Field(type => String) personLocation?: string;

  @Field(type => String) company?: string;
  @Field(type => String) companyDomain?: string;
  @Field(type => String) companyLinkedinUrl?: string;
  @Field(type => String) industry?: string;
  @Field(type => String) companyLocation?: string;
  @Field(type => String) employeeCount?: string;
  @Field(type => Int) employeeCountMin?: number;
  @Field(type => Int) employeeCountMax?: number;
  @Field(type => String) revenue?: string;
  @Field(type => Int) revenueMin?: number;
  @Field(type => Int) revenueMax?: number;

  @Field(type => [EigenLeadProviderDoc]) providers!: EigenLeadProviderDoc[];

  @Field(type => String) status!: string;
  @Field(type => String) lastVerifiedAt?: string;
  @Field(type => String) lastUsedAt?: string;
  @Field(type => Int) useCount?: number;
  @Field(type => String) createdAt!: string;
  @Field(type => String) updatedAt!: string;
}
